export class UpdateMPAPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaPolicy",
            "baseName": "mpaPolicy",
            "type": "MPAPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateMPAPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
